interface CostTickerProps {
  cost: number;
}

export function CostTicker({ cost }: CostTickerProps) {
  return (
    <div className="border-t px-4 py-2 text-xs text-muted-foreground flex justify-between items-center">
      <span>Estimated Cost</span>
      <span className="font-mono font-medium">${cost.toFixed(4)}</span>
    </div>
  );
}
